import {
    SET_MEDIA_DEVICES_ENABLED,
    SET_MODAL_OPENING_COUNT,
    SET_REQUIRES_PERMISSION_REQUEST,
    SET_LANGUAGE,
    SET_LIGHT_REGISTRATION,
    SET_RETURN_TO,
} from './constants';

export const setMediaDevicesEnabled = payload => ({ type: SET_MEDIA_DEVICES_ENABLED, payload });
export const setModalOpeningCount = payload => ({ type: SET_MODAL_OPENING_COUNT, payload });
export const setRequiresPermissionRequest = payload => ({ type: SET_REQUIRES_PERMISSION_REQUEST, payload });
export const setLanguage = payload => ({ type: SET_LANGUAGE, payload });
export const setLightRegistration = payload => ({ type: SET_LIGHT_REGISTRATION, payload });
export const setReturnTo = payload => ({ type: SET_RETURN_TO, payload });
